import { render, staticRenderFns } from "./DepartmentGridItem.vue?vue&type=template&id=344c292b&"
import script from "./DepartmentGridItem.vue?vue&type=script&lang=ts&"
export * from "./DepartmentGridItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports